
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-teal-700 py-20 px-8 lg:px-32">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Nexonix</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              Professional AI consulting and technology services for enterprise organizations.
            </p>
            <div className="text-white/80 text-sm space-y-2">
              <p>295 E Swedesford Road</p>
              <p>Wayne, PA 19087</p>
              <p>United States</p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <div className="text-white/80 text-sm space-y-2">
              <p>
                <a href="tel:+12673147514" className="hover:text-white transition-colors cursor-pointer">
                  +1-267-314-7514
                </a>
              </p>
              <p>
                <a href="mailto:raj@nexonix.us" className="hover:text-white transition-colors cursor-pointer">
                  raj@nexonix.us
                </a>
              </p>
              <div className="mt-4">
                <a
                  href="https://www.linkedin.com/company/nexonix"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-8 h-8 text-white/80 hover:text-white transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-2xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link
                to="/services"
                className="block text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
              >
                Services
              </Link>
              <Link
                to="/pricing"
                className="block text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
              >
                Pricing & Billing
              </Link>
              <Link
                to="/why-nexonix"
                className="block text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
              >
                Why Nexonix
              </Link>
              <Link
                to="/contact"
                className="block text-white/80 text-sm hover:text-white transition-colors cursor-pointer"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8">
          {/* Bottom Footer */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Copyright */}
            <div className="text-white/60 text-sm text-center md:text-left">
              © 2025 Nexonix. All rights reserved.
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <Link
                to="/privacy"
                className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Terms of Service
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Powered by Readdy
              </a>
            </div>
          </div>

          {/* Business Type Disclaimer */}
          <div className="mt-6 text-center">
            <p className="text-white/50 text-xs">
              Nexonix provides professional consulting services and does not sell physical products or consumer digital goods.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
